import { render, staticRenderFns } from "./wxwl-waimao.vue?vue&type=template&id=373f122e"
import script from "./wxwl-waimao.vue?vue&type=script&lang=js"
export * from "./wxwl-waimao.vue?vue&type=script&lang=js"
import style0 from "./wxwl-waimao.vue?vue&type=style&index=0&id=373f122e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports